import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/login.ts
import { generateMd5, getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var loginWithPassword = (_0) => __async(null, [_0], function* ({ email, password, locale }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  try {
    const signature = generateMd5(email);
    const captcha = yield resolveCaptcha("login");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: "/login",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({
          email,
          password
        }, captcha), {
          signature,
          app_source: (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.appSource,
          login_with: "email",
          lang
        }))
      }
    });
    if (((_e = data == null ? void 0 : data.status) == null ? void 0 : _e.toLowerCase()) === "success" && ((_f = data == null ? void 0 : data.data) == null ? void 0 : _f.access_token)) {
      return {
        new_user: false,
        user: data.data
      };
    }
    const possibleDataError = data == null ? void 0 : data.data;
    const msg = typeof (possibleDataError == null ? void 0 : possibleDataError[0]) === "string" ? possibleDataError[0] : ((_g = data == null ? void 0 : data.error) == null ? void 0 : _g.mobile) || ((_h = data == null ? void 0 : data.error) == null ? void 0 : _h.phone) || ((_i = data == null ? void 0 : data.error) == null ? void 0 : _i.cell_number) || ((_j = data == null ? void 0 : data.error) == null ? void 0 : _j.email) || ((_l = (_k = data == null ? void 0 : data.original) == null ? void 0 : _k.error) == null ? void 0 : _l.description) || ((_m = data == null ? void 0 : data.error) == null ? void 0 : _m.description) || ((_o = (_n = data == null ? void 0 : data.error) == null ? void 0 : _n.captcha) == null ? void 0 : _o[0]);
    const finalMsg = Array.isArray(msg) ? msg[0] : msg;
    throw new Error(finalMsg);
  } catch (error) {
    throw new Exception({
      error,
      name: "loginException",
      context: { tags: { journey: "auth" }, extra: { email } }
    });
  }
});

export {
  loginWithPassword
};
//# sourceMappingURL=chunk-DQDOOV4R.mjs.map